import React from "react";

/**
 * Shared component to render Relationship Category, Type, and Status fields.
 * It supports either a custom Select component (e.g. SelectField) or
 * native <select> elements when no custom component is provided.
 */
const CategoryTypeStatusFields = ({
  SelectComponent, // optional. If not provided, native <select> is used
  values, // { relationship_category, relationship_type, relationship_status }
  options, // { categories: [], types: [], statuses: [] }
  onChange, // (e) => void
  disabled = {}, // { category?: boolean, type?: boolean, status?: boolean }
  labels = {
    category: "Relationship Category",
    type: "Relationship Type",
    status: "Relationship Status",
  },
  errors = {}, // { relationship_category?: string, relationship_type?: string, relationship_status?: string }
  className = "",
  show = { category: true, type: true, status: true },
}) => {
  const { relationship_category, relationship_type, relationship_status } = values || {};
  const { categories = [], types = [], statuses = [] } = options || {};
  const dis = disabled || {};

  const renderSelect = (cfg) => {
    const { label, name, value, opts, disabled } = cfg;
    if (SelectComponent) {
      return (
        <div className="form-group">
          <SelectComponent
            label={label}
            name={name}
            value={value}
            onChange={onChange}
            options={opts}
            disabled={disabled}
          />
        </div>
      );
    }
    return (
      <div className="form-group ">
        <label>{label}</label>
        <select name={name} value={value} onChange={onChange} disabled={disabled}>
          {opts.map((o) => (
            <option key={o.value} value={o.value} disabled={o.disabled}>
              {o.label}
            </option>
          ))}
        </select>
      </div>
    );
  };

  return (
    <div className={className}>
      {show.category && (
        <>
          {renderSelect({
            label: labels.category,
            name: "relationship_category",
            value: relationship_category,
            opts: [{ value: "", label: "Select Category" }, ...categories.map((c) => ({ value: c, label: c }))],
            disabled: !!dis.category,
          })}
          {errors.relationship_category ? (
            <p className="error-message name-align-left">{errors.relationship_category}</p>
          ) : null}
        </>
      )}

      {show.type && (
        <>
          {renderSelect({
            label: labels.type,
            name: "relationship_type",
            value: relationship_type,
            opts: [{ value: "", label: "Select Type" }, ...types.map((t) => ({ value: t, label: t }))],
            disabled: !!dis.type || !relationship_category,
          })}
          {errors.relationship_type ? (
            <p className="error-message name-align-left">{errors.relationship_type}</p>
          ) : null}
        </>
      )}

      {show.status && (
        <>
          {renderSelect({
            label: labels.status,
            name: "relationship_status",
            value: relationship_status,
            opts: [{ value: "", label: "Select Status" }, ...statuses.map((s) => ({ value: s, label: s }))],
            disabled: !!dis.status,
          })}
          {errors.relationship_status ? (
            <p className="error-message name-align-left">{errors.relationship_status}</p>
          ) : null}
        </>
      )}
    </div>
  );
};

export default CategoryTypeStatusFields;
